import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const ClearIcon = () => {
  const {getThemeColor} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.0827 3.74047L10.2602 2.91797L6.99935 6.1788L3.73852 2.91797L2.91602 3.74047L6.17685 7.0013L2.91602 10.2621L3.73852 11.0846L6.99935 7.8238L10.2602 11.0846L11.0827 10.2621L7.82185 7.0013L11.0827 3.74047Z"
        fill={getThemeColor("primary-color")}
      />
    </svg>
  );
};

export default ClearIcon;
